import { cn } from '@/lib/utils';
import { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { FileSpec } from '@chainlit/react-client';

import UkisBrand from '@/components/UkisBrand';

import MessageComposer from './MessageComposer';

interface Props {
  fileSpec: FileSpec;
  onFileUpload: (payload: File[]) => void;
  onFileUploadError: (error: string) => void;
  autoScrollRef: MutableRefObject<boolean>;
  variant?: 'welcome' | 'chat';
}

export default function ChatFooter({ variant = 'chat', ...props }: Props) {
  const { t, i18n } = useTranslation();
  const disclaimerKey = 'chat.disclaimer';
  const translatedDisclaimer = t(disclaimerKey);
  const disclaimer =
    translatedDisclaimer === disclaimerKey
      ? i18n.language.toLowerCase().startsWith('en')
        ? 'FONGPT can make mistakes. Check important information.'
        : 'FONGPT može da pogreši. Proverite važne informacije.'
      : translatedDisclaimer;

  return (
    <div className={cn('relative flex flex-col items-center gap-2 w-full')}>
      <MessageComposer {...props} variant={variant} />
      {variant === 'chat' ? (
        <div className="fongpt-disclaimer mt-1 max-w-full px-2 text-secondary">
          <span>{disclaimer}</span>
          <a
            href="https://ukisai.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex shrink-0 items-center"
          >
            <UkisBrand className="fongpt-disclaimer-brand opacity-90 transition-opacity hover:opacity-100" />
          </a>
        </div>
      ) : null}
    </div>
  );
}
